import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import type { ButtonProps } from '@atlaskit/button/button';
import Button from '@atlaskit/button/button';
import type {
	ComponentType,
	RefAttributes,
	DO_NOT_USE_OR_YOU_WILL_BE_FIRED_CALLBACK_REF_RETURN_VALUES,
	RefObject,
} from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CustomAppearanceButton: ComponentType<
	{
		isSelected?: boolean;
	} & Omit<ButtonProps & RefAttributes<HTMLElement>, 'ref'> & {
			ref?:
				| ((
						instance: HTMLElement | null,
				  ) =>
						| void
						| DO_NOT_USE_OR_YOU_WILL_BE_FIRED_CALLBACK_REF_RETURN_VALUES[keyof DO_NOT_USE_OR_YOU_WILL_BE_FIRED_CALLBACK_REF_RETURN_VALUES])
				| RefObject<HTMLElement>
				| null
				| undefined;
		} & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled(Button)<{ isSelected?: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		color: `${(props) =>
			props.isSelected ? token('color.text.selected') : token('color.text.subtlest')} !important`,
		minWidth: '32px',
	},
});
